import CardActionRoot, { Props } from './CardAction'

export default function CardAction(props: Props) {
  return <CardActionRoot {...props} />
}

export type { Props }
